import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { House, Broadcast, PlusSquare, Gift, ChatCircleDots, User } from "@phosphor-icons/react";

const items = [
  { to: "/", icon: House, label: "Home", testid: "nav-feed" },
  { to: "/live", icon: Broadcast, label: "Live", testid: "nav-live" },
  { to: "/hub", icon: PlusSquare, label: "Create", testid: "nav-create", primary: true },
  { to: "/gifts", icon: Gift, label: "Gifts", testid: "nav-gifts" },
  { to: "/messages", icon: ChatCircleDots, label: "Inbox", testid: "nav-messages" },
  { to: "/profile", icon: User, label: "Me", testid: "nav-profile" },
];

export default function BottomNav() {
  const location = useLocation();
  const hide =
    ["/login", "/signup", "/welcome", "/verify", "/admin", "/data-safety", "/studio", "/voice", "/rooms", "/rooms/new", "/shop", "/cashout"].includes(location.pathname) ||
    location.pathname.startsWith("/rooms/") ||
    location.pathname.startsWith("/messages/") ||
    location.pathname.startsWith("/live/go") ||
    location.pathname.startsWith("/live/watch/");
  if (hide) return null;
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-20 sm:bottom-4 left-1/2 -translate-x-1/2 z-[70] crystal-glass rounded-full px-2 sm:px-3 py-2 flex items-center gap-0.5 sm:gap-2"
    >
      {items.map(({ to, icon: Icon, label, testid, primary }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          data-testid={testid}
          className={({ isActive }) =>
            `relative flex flex-col items-center justify-center px-2.5 sm:px-4 py-2 rounded-full transition-all duration-300 ease-out
             ${isActive ? "text-papaya" : "text-white/60 hover:text-white hover:-translate-y-0.5"}`
          }
        >
          {primary ? (
            <span className="absolute -top-1 -inset-x-1 bottom-0 rounded-full bg-papaya papaya-glow opacity-90 -z-10" />
          ) : null}
          <Icon size={primary ? 26 : 22} weight={primary ? "fill" : "duotone"} className={primary ? "text-ink" : ""} />
          <span className={`text-[10px] tracking-[0.18em] uppercase font-bold mt-0.5 ${primary ? "text-ink" : ""}`}>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
